export default __webpack_public_path__ + "static/@Domain-Pools-Australia_1-cfb06a30d30897f9f64968ced177981e.jpg";